<template>
  <section>
    <div class="start-here container">
      <h2>Start here for...</h2>
      <div>
        <router-link :to="{ name: 'Category', params: { topic: 'laugh' }}"><span>A Laugh</span></router-link>
        <router-link :to="{ name: 'Category', params: { topic: 'good-cry' }}"><span>A Good Cry</span></router-link>
        <router-link :to="{ name: 'Category', params: { topic: 'surprise' }}"><span>A Surprise</span></router-link>
        <router-link :to="{ name: 'Category', params: { topic: 'staff-faves' }}"><span>Staff Faves</span></router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'start-here'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  .start-here
    padding: 30px 15px
    +tablet
      padding-top: 106px
      padding-bottom: 210px
    h2
      font-weight: bold
      font-size: 36px
      margin-bottom: 42px
      +tablet
        margin-bottom: 56px
        font-size: 40px
    > div
      display: flex
      justify-content: flex-start
      flex-wrap: wrap
      +desktop
        justify-content: space-between
        flex-wrap: nowrap
      > a
        +until($desktop)
          margin: 10px 4% 10px 0
          width: 48%
          height: auto
          &:nth-child(2n)
            margin-right: 0
        font-size: 20px
        display: flex
        width: 228px
        background-color: #fff
        color: $textColor
        border-radius: 50%
        border: 8px solid
        align-items: center
        justify-content: center
        font-weight: bold
        transition: all 250ms
        position: relative
        overflow: hidden
        +smTablet
          font-size: 36px
        +desktop
          font-size: 33px
        &:nth-child(1)
          background-color: $green
          border-color: $green
          &:after
            background-image: url('./LST_StartHereImages_Laugh.jpg')
        &:nth-child(2)
          background-color: $turquoise
          border-color: $turquoise
          &:after
            background-image: url('./LST_StartHereImages_Cry.jpg')
        &:nth-child(3)
          background-color: $yellow
          border-color: $yellow
          &:after
            background-image: url('./LST_StartHereImages_Surprise.jpg')
        &:nth-child(4)
          background-color: $orange
          border-color: $orange
          &:after
            background-image: url('./LST_StartHereImages_StaffPicks.jpg')
        &:after
          content: ''
          position: absolute
          top: 0
          left: 0
          right: 0
          bottom: 0
          opacity: 0
          transition: opacity 250ms
          background-size: cover
          background-position: center center
        span
          position: relative
          z-index: 1
          width: 100%
          height: 0
          padding: 50% 0
          line-height: 0
          text-align: center
        &:hover
          color: #fff
          text-shadow: 0 3px 6px rgba(0,0,0,0.16)
          &:after
            opacity: 0.35
            transition: opacity 250ms linear 100ms
</style>



// WEBPACK FOOTER //
// StartHere.vue?dfdebf5e